module.exports = __webpack_public_path__ + "static/media/vitaminese.c5e623f5.png";